import { render } from "./Graphs.vue?vue&type=template&id=0b5b479f"
import script from "./Graphs.vue?vue&type=script&lang=js"
export * from "./Graphs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__